var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.vacancies.length == 0)?_c('empty-view',{attrs:{"title":"Geen vacatures","message":"Er zijn geen openstaande vacatures beschikbaar. Vacatures worden op de pagina van de markt getoond en zijn deelbaar via social media.","actionText":"Stel een vacature op"},on:{"action":function($event){_vm.$modal.show('add-recruitment-modal');}}}):_vm._e(),_vm._v(" "),_c('add-recruitment-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fe8e993","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/market/RecruitmentPage.vue
// module id = 556
// module chunks = 1